import React from 'react'
import StepTemplate from './StepTemplate'
import { Pregunta, PREGUNTAS } from '../../data/ocean'

const CONSIGNAS: Pregunta[] = PREGUNTAS.slice(33, 44)

export default function Step4() {
  return <StepTemplate step={4} consignas={CONSIGNAS} />
}
